import { Injectable } from '@angular/core';


@Injectable()
export class ValidationService {

    constructor() {
    }

    validateDate (date:string) {
        const date_regex = /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/;

        if (date_regex.test(date)) {

            const a = new Date(date) < new Date();
            return a;
        }

        return false;
    }
}